import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    sidebarShow: "responsive",
    sidebarMinimize: false,
    asideShow: false,
    darkMode: false,
    globalLanguages: [],
    email: "",
    timestamp: null,
    userData: {
      token: null,
      user: null,
      brands: null,
      permissions: null
    },
    timestamp: null,
    currentBrandID: null,
    brandList: null,
    brandDetail: null,
    permission: null,
    loading: {
      show: true,
      progress: 0
    },
    showDropdownBrand: true
  },
  mutations: {
    toggleSidebarDesktop(state) {
      const sidebarOpened = [true, "responsive"].includes(state.sidebarShow);
      state.sidebarShow = sidebarOpened ? false : "responsive";
    },
    toggleSidebarMobile(state) {
      const sidebarClosed = [false, "responsive"].includes(state.sidebarShow);
      state.sidebarShow = sidebarClosed ? true : "responsive";
    },
    set(state, [variable, value]) {
      state[variable] = value;
    },
    toggle(state, variable) {
      Vue.set(state, variable, !state[variable]);
    },
    setGlobalLanguages(state, list) {
      list.forEach(item => {
        state.globalLanguages.push({ ...item });
      });
    },
    setEmail(state, val) {
      state.email = val;
    },
    UPDATE_TIMESTAMP: (state, payload) => {
      Vue.set(state, "timestamp", payload);
    },
    UPDATE_USERDATA: (state, payload) => {
      Vue.set(state, "userData", payload);
    },
    UPDATE_PERMISSION: (state, payload) => {
      Vue.set(state, "permission", payload);
    },
    UPDATE_BRANDDETAIL: (state, payload) => {
      Vue.set(state, "brandDetail", payload);
    },
    UPDATE_BRANDLIST: (state, payload) => {
      Vue.set(state, "brandList", payload);
    },
    UPDATE_CURRENT_BRANDID: (state, payload) => {
      var brandDetail = state.brandList.find(item => item.id == payload);
      Vue.set(state, "currentBrandID", payload);
      Vue.set(state, "brandDetail", brandDetail);
    },
    UPDATE_DATA_PROGRESS: state => {
      var progress = 0;

      // if (state.userData != null) progress += 20;
      if (state.userData != null) progress += 100;
      if (state.currentBrandID != null) progress += 30;
      if (state.brandList != null) progress += 20;
      if (state.brandDetail != null) progress += 30;
      Vue.set(state.loading, "progress", progress);
      if (progress == 100) {
        Vue.set(state.loading, "show", false);
      } else {
        Vue.set(state.loading, "show", true);
      }
    },
    UPDATE_SHOWDROPDOWNBRAND: (state, payload) => {
      state.showDropdownBrand = payload;
    },
    UPDATE_TIMESTAMP: (state, payload) => {
      Vue.set(state, "timestamp", payload);
    },
  },
  actions: {
    setUserData(context, payload) {
      context.commit("UPDATE_USERDATA", payload);
    },
    deleteUserData(context) {
      context.commit("UPDATE_USERDATA", {});
    },
    setPermission(context, payload) {
      context.commit("UPDATE_PERMISSION", payload);
    },
    setBrandDetail(context, payload) {
      context.commit("UPDATE_BRANDDETAIL", payload);
    },
    setBrandList(context, payload) {
      context.commit("UPDATE_BRANDLIST", payload);
    },
    setCurrentBrandID(context, payload) {
      context.commit("UPDATE_CURRENT_BRANDID", payload);
    },
    updateDataProgress(context) {
      context.commit("UPDATE_DATA_PROGRESS");
    },
    setShowDropdownBrand(context, payload) {
      context.commit("UPDATE_SHOWDROPDOWNBRAND", payload);
    },
    setTimestamp(context, payload) {
      context.commit("UPDATE_TIMESTAMP", payload);
    },
  },
  getters: {
    getUserData: state => () => {
      return state.userData;
    },
    getUserDetail: state => () => {
      return state.userData;
    },
    getUserBrandsIDList: state => () => {
      return state.userData.brands;
    },
    getUserBrandsDetailList: state => () => {
      return state.userData.brands;
    },
    getUserBrandsDetailByID: state => brandID => {
      return state.userData.brands.find(item => item.brandID == brandID);
    },
    getUserPermissionsList: state => () => {
      return state.userData.permissions;
    },
    getUserPermissionsByBrandID: state => brandID => {
      return state.userData.permissions.find(item => item.brandID == brandID)
        .permission;
    },
    getPermission: state => () => {
      return state.permission;
    },
    getBrandDetail: state => () => {
      return state.brandDetail;
    },
    getBrandList: state => () => {
      return state.brandList;
    },
    getCurrentBrandID: state => () => {
      return state.currentBrandID;
    },
    ishavePermission: state => userPermisstion => {
      if (userPermisstion == -1 || state.permission == null) {
        return true;
      } else {
        return userPermisstion.some(r => state.permission.includes(r));
      }
    },
    getDataLoadingProgress: state => () => {
      return state.loading.progress;
    },
    getDataLoadingProgressByData: state => () => {
      return {
        userData: state.userData != null,
        currentBrandID: state.currentBrandID != null,
        brandList: state.brandList != null,
        brandDetail: state.brandDetail != null,
        permission: state.permission != null
      };
    },
    isLoading: state => () => {
      return state.loading.show;
    },
    getShowDropdownBrand: state => {
      return state.showDropdownBrand;
    },
    getTimestamp: state => () => {
      return state.timestamp;
    },
  }
});

// const state = {
//   sidebarShow: "responsive",
//   sidebarMinimize: false,
//   asideShow: false,
//   darkMode: false,
//   globalLanguages: [],
//   email: ""
// };

// const mutations = {
//   toggleSidebarDesktop(state) {
//     const sidebarOpened = [true, "responsive"].includes(state.sidebarShow);
//     state.sidebarShow = sidebarOpened ? false : "responsive";
//   },
//   toggleSidebarMobile(state) {
//     const sidebarClosed = [false, "responsive"].includes(state.sidebarShow);
//     state.sidebarShow = sidebarClosed ? true : "responsive";
//   },
//   set(state, [variable, value]) {
//     state[variable] = value;
//   },
//   toggle(state, variable) {
//     Vue.set(state, variable, !state[variable]);
//   },
//   setGlobalLanguages(state, list) {
//     list.forEach(item => {
//       state.globalLanguages.push({ ...item });
//     });
//   },
//   setEmail(state, val) {
//     state.email = val;
//   }
// };

// export default new Vuex.Store({
//   state,
//   mutations
// });
